export default __webpack_public_path__ + "static/media/bg.c6d39b39.png";